import { EmployeeWiseCheckRollMonthlySummaryTable, TableContentWithoutEditDateFromat } from '../../../Common/Table/tableContent';
import React from "react";
import tokenService from '../../../../Common/tokenDecoder';

export default class ComponentToPrint extends React.Component {
    render() {

        const data = this.props.data;
        const rowNames = this.props.rowNames;
        const searchData = this.props.searchData;
        const totalCollections = this.props.totalCollections;
        const columeNames = this.props.columeNames;
        const inishialColumName = [{
            title: 'Date', field: 'weightReadTime', render: rowData => rowData.weightReadTime, headerStyle: {
                color: '#000000',
                textAlign: 'center',
                fontWeight: 'bold'
            }, cellStyle: { textAlign: 'left' }

        }]

        return (
            <div>
                <h3><center><u>Day Wise Employee Check Roll Monthly Detail Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division}</div>
                    <div className="col"><b>Plucking Type : </b> {searchData.pluckingTy}</div>
                    <div className="col"><b>From Date : </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date : </b> {searchData.toDate}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>
                <table id="totalCrop">
                    <thead>
                        <tr>
                            <th style={{ fontWeight: "bold", textAlign: "left" }}>Emp EPF</th>
                            <th style={{ fontWeight: "bold", textAlign: "left" }}>Emp Reg</th>
                            <th style={{ fontWeight: "bold", textAlign: "left" }}>Emp Name</th>
                            <th style={{ fontWeight: "bold", textAlign: "right" }}>Checkroll (Kg)</th>
                            <th style={{ fontWeight: "bold", textAlign: "right" }}>Extra (Kg)</th>
                            <th style={{ fontWeight: "bold", textAlign: "right" }}>Total (Kg)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <EmployeeWiseCheckRollMonthlySummaryTable
                            data={data}
                            contentRowNames={rowNames}
                            hasEdit={false}
                        />
                    </tbody>
                    <tfoot>
                        <tr>
                            <td><h6>Total</h6></td>
                            <td></td>
                            <td></td>
                            <td style={{ textAlign: "right" }}><h6>{totalCollections.totalAmount}</h6></td>
                            <td style={{ textAlign: "right" }}><h6>{totalCollections.extraKg}</h6></td>
                            <td style={{ textAlign: "right" }}><h6>{totalCollections.allTotal}</h6></td>
                        </tr>
                    </tfoot>
                </table>
                <hr />
            </div>
        );
    }
}